import React, { memo, useMemo } from 'react'
import { Link as RouterLink } from 'react-router'

import { TradeRoute } from '@root/features/routing/model'

import type { Network } from '@root/entities/network/model/network'
import type { PairAddress } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type NavigateToPairOptions = { address: PairAddress; network: Network }

type Props<P extends NavigateToPairOptions> = {
  pair: P
} & ClassNameProps &
  React.HTMLAttributes<HTMLAnchorElement>

export const PairLinkInner = <P extends NavigateToPairOptions>({
  pair,
  className,
  ...rest
}: Props<P>) => {
  const tradingRoute = useMemo(
    () =>
      TradeRoute.build({ pairAddress: pair.address, network: pair.network }),
    [pair.address, pair.network],
  )

  return <RouterLink to={tradingRoute} className={className} {...rest} />
}

export const PairLink = memo(PairLinkInner) as typeof PairLinkInner
